<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">系统</a></el-breadcrumb-item>
          <el-breadcrumb-item>操作员</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="user" label-width="160px" size="medium">
        <el-form-item label="账号">
          <el-col :span="12">
            <el-tooltip class="item" effect="dark" content="子账号必须以@主账号结尾" placement="right">
              <el-input v-model="user.account" :disabled="(user.id!=0)" ></el-input>
            </el-tooltip>
          </el-col>
        </el-form-item>
        <el-form-item label="姓名">
          <el-col :span="12">
            <el-input v-model="user.name" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="权限">
          <el-col :span="12">             
            <el-select v-model="roleSelectValue" 
              value-key="id" 
              placeholder="请选择"  
              :disabled="(user.isSystem==true)"
              @change="changeRole($event)" >
              <el-option
                @change="changeRole($event,item)"
                v-for="item in userRoles"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        
        <el-form-item label="所属代理" v-if="agentVisable">
          <el-col :span="12">
            <el-input v-model="merchantName" readonly placeholder="名称">
              <el-button  slot="append" icon="el-icon-search" @click="selectAgentHandle"></el-button>
            </el-input>   
          </el-col>
        </el-form-item> 
         <el-form-item label="操作店铺">
          <el-col :span="12">
            <el-input v-model="storeName" readonly placeholder="名称">
              <el-button  slot="append" icon="el-icon-search" @click="selectStoreHandle"></el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="密码">
          <el-col :span="12">
            <el-tooltip class="item" effect="dark" content="编辑用户时，不修改密码可以不用输入" placement="right">
              <el-input v-model="user.password" show-password ></el-input>
            </el-tooltip>
          </el-col>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-col :span="12">
            <el-input v-model="password2" show-password></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="手机号">
          <el-col :span="12">
            <el-input v-model="user.mobile" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="备注">
          <el-col :span="12">
            <el-input v-model="user.memo" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item >
          <el-col :span="12">
            <el-button type="primary" @click="SaveUserInfo">保 存</el-button>
            <el-button style="margin-left: 8px" @click="handleBack">返回列表</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>
    <GetChainStore v-bind:dialogStore="dialogStore" @UpdateSote="UpdateSote"></GetChainStore> 
  </section>
</template>
<script  type='text/ecmascript-6'>
  import GetChainStore from '@/components/GetChainStore'
  export default {
    props:{
    },
    data (){
      return {
        user:{},        
        userRoles:[],
        type:0,
        roleSelectValue:{},
        password2:'',
        storeName:'',
        merchantName:'',
        dialogStore:{
          isShow:false
        },
      }
    },
    computed:{
      agentVisable:function(){
        if(this.type==1)
          return true
        else 
          return false
      }
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/User/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.user = resp.data.user
        that.userRoles = resp.data.userRoles
        that.storeName = resp.data.storeName
        that.merchantName = resp.data.merchantName
        that.user.password = ''
        that.roleSelectValue = resp.data.userRoles.filter(function(elem, index,arr){
            return elem.id==that.user.roleId
          })[0]   
        that.type = that.roleSelectValue.type
      })
    },
    methods:{
      changeRole:function(e,scope){
        this.user.roleId = e.id
        this.type = e.type
        console.log(this.user.roleId)
      },
      selectStoreHandle:function(){
        this.dialogStore.isShow = true
      },  
      UpdateSote:function(id,name,merchanId,merchantName){
        this.user.chainStoreId = id 
        this.storeName = name 
        if(this.type==2){
          this.user.areaId = merchanId 
          this.merchantName = merchantName
        }
      },
      selectAgentHandle:function(){
        this.dialogMerchant.isShow = true
      },
      SaveUserInfo:function(){     
        if(this.user.password != this.password2){
          this.$message.warning("两次输入的密码不一致!");
          return;
        } 
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/User/Save',     
          data:that.user    
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },      
      handleBack(){
        var that = this
        this.$confirm('请先确定已经保存内容！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$router.push({
            name: 'user',
            params: {
              queryParam: that.$route.params.queryParam
            }
          })
        }).catch(() => {
            
        });
      }
    },
    components:{
      GetChainStore
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
</style>